import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATIC_VIDEOS_URLS } from 'modules/core/constants';

import { LearningWrapper } from '../common/LearningWrapper/LearningWrapper';
import { CardForm, TitleH1, MainVideo, Container, TextBold } from '../styles';
import { LEARNING_PATHS } from '../Learning.const';

export const LearningKeyFactors: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LearningWrapper prevPageLink={LEARNING_PATHS.start} nextPageLink={LEARNING_PATHS.creditHistory}>
      <TitleH1>{t('components.learningLink.keyFactors.title')}</TitleH1>
      {t('components.learningLink.keyFactors.description')}
      <CardForm>
        <TextBold>
          <ol>
            <li>{t('components.learningLink.creditHistory.title').toUpperCase()}</li>
            <li>{t('components.learningLink.affordability.title').toUpperCase()}</li>
            <li>{t('components.learningLink.loanToValue.title').toUpperCase()}</li>
            <li>{t('components.learningLink.lengthOfLoan.title').toUpperCase()}</li>
          </ol>
        </TextBold>
      </CardForm>
      <Container>
        <MainVideo controls autoPlay={false} playsInline>
          <source src={STATIC_VIDEOS_URLS.learningVideo} type="video/mp4" />
        </MainVideo>
      </Container>
    </LearningWrapper>
  );
};
